import { FileResult } from '../../api';
import DocumentsService from '../../api/services/documents.service';
import { useAppInsightsLogger } from '../../logging/AppInsightsLogger';
import { globalSlice } from '../common';
import { AppThunk } from '../store';
import { documentsSlice, selectDocumentCategoryById } from './documents.slice';

const appInsightsLogger = useAppInsightsLogger();
const documentsService = DocumentsService.getInstance();

export const getDocumentHeaders =
  (documentCategoryId: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      // Check if headers for this category are already loaded
      const existingCategory = selectDocumentCategoryById(getState().documents.documentCategories, documentCategoryId);

      if (existingCategory && existingCategory.HasLoadedDocumentHeaders) {
        return;
      }

      dispatch(documentsSlice.actions.setIsLoadingDocumentHeaders(true));

      const { data } = await documentsService.getDocumentHeaders(documentCategoryId);

      if (data.IsSuccess) {
        dispatch(
          documentsSlice.actions.setDocumentHeaders({
            documents: data.ResultObject,
            documentCategoryId: documentCategoryId,
          })
        );
      } else {
        dispatch(globalSlice.actions.setErrorDialogContent({ messages: data.ErrorMessages }));
      }
      dispatch(documentsSlice.actions.setIsLoadingDocumentHeaders(false));
    } catch (error) {
      appInsightsLogger.trackException({
        exception: error,
      });
    }
  };

export const getDocumentHeadersSearch = (): AppThunk => async (dispatch) => {
  try {
    dispatch(documentsSlice.actions.setIsLoadingDocumentHeaders(true));
    const { data } = await documentsService.getDocumentHeadersSearch();

    if (data.IsSuccess) {
      dispatch(documentsSlice.actions.setDocumentHeaders({ documents: data.ResultObject, documentCategoryId: '' }));
    } else {
      dispatch(globalSlice.actions.setErrorDialogContent({ messages: data.ErrorMessages }));
    }
    dispatch(documentsSlice.actions.setIsLoadingDocumentHeaders(false));
  } catch (error) {
    appInsightsLogger.trackException({
      exception: error,
    });
  }
};

/*
 * Document Categories
 */

export const getDocumentCategories =
  (parentCategoryId?: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(documentsSlice.actions.setIsLoadingDocumentCategories(true));

      const { data } = await documentsService.getDocumentCategories(parentCategoryId);

      if (data.IsSuccess) {
        dispatch(documentsSlice.actions.setDocumentCategories(data.ResultObject || []));
      } else {
        dispatch(globalSlice.actions.setErrorDialogContent({ messages: data.ErrorMessages }));
      }

      dispatch(documentsSlice.actions.setIsLoadingDocumentCategories(false));
    } catch (error) {
      dispatch(documentsSlice.actions.setIsLoadingDocumentCategories(false));
      appInsightsLogger.trackException({
        exception: error,
      });
    }
  };

export const getDocumentFile =
  (documentDetailId: string): AppThunk<Promise<FileResult | null>> =>
  async (dispatch) => {
    try {
      dispatch(documentsSlice.actions.setIsLoadingDocumentDetailFile(true));

      const { data } = await documentsService.getDocumentFile(documentDetailId);

      if (data.IsSuccess) {
        const fileResult: FileResult = {
          FileContentType: data.ResultObject.FileContentType,
          FileName: data.ResultObject.FileName,
          FileData: data.ResultObject.FileData,
        };

        dispatch(documentsSlice.actions.setIsLoadingDocumentDetailFile(false));
        return fileResult;
      } else {
        dispatch(globalSlice.actions.setErrorDialogContent({ messages: data.ErrorMessages }));
        dispatch(documentsSlice.actions.setIsLoadingDocumentDetailFile(false));
        return null;
      }
    } catch (error) {
      dispatch(documentsSlice.actions.setIsLoadingDocumentDetailFile(false));
      appInsightsLogger.trackException({
        exception: error,
      });
      return null;
    }
  };
